module.exports = __webpack_public_path__ + "static/img/2.34ee517.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/zh/2.png
// module id = NHo2
// module chunks = 0